// extracted by mini-css-extract-plugin
export var carrierIcon = "_ud-0";
export var carrierLogo = "_ud-1";
export var detailsSection = "_ud-2";